import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-recursive-list',
  templateUrl: './recursive-list.component.html',
  styleUrls: ['./recursive-list.component.scss']
})
export class RecursiveListComponent implements OnInit {
  @Input() block: any;

  constructor(public navigationService: NavigationService) { }

  ngOnInit(): void {
  }

}
